import React from 'react';
import { EntityDescription } from '../../Api/interfaces';
import FieldsTable from './FieldsTable';
import LinksTable from './LinksTable';
import PickupsTable from './PickupsTable';
import RelationsTable from './RelationsTable';

import './styles.css';

interface Props {
  entity: EntityDescription;
  onTypeClicked?: (type: string) => void;
}
interface State {
  filter: string;
}
export default class EntityDetails extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { filter: '' };
  }

  private inputChangedHandler = (event: any): void => {
    this.setState({ filter: event.target.value });
  };

  private renderValidStates(entity: EntityDescription): JSX.Element {
    return (
      <tr>
        <td valign="top">
          <div className="propertyName">Valid States</div>
        </td>
        <td>
          {entity.validStates.map((st) => (
            <div key={st}>{st}</div>
          ))}
        </td>
      </tr>
    );
  }

  public render(): JSX.Element {
    const { entity, onTypeClicked } = this.props;
    const { filter } = this.state;
    return (
      <div className="detailsContainer">
        <div>
          <div className="detailsHeader">
            <strong className="label">{entity.label}</strong>
          </div>
          <table>
            <tbody>
              <tr>
                <td>
                  <div className="propertyName">Type</div>
                </td>
                <td>
                  {entity.typeName}
                  <span className="propertySearchBoxWrapper">
                    <input
                      className="search"
                      type="text"
                      placeholder="Search properties..."
                      onChange={this.inputChangedHandler}
                    />
                  </span>
                </td>
              </tr>
              <tr className="spacer"></tr>
              {entity.pickups && entity.pickups.length > 0 ? (
                <PickupsTable entity={entity} />
              ) : null}
              <tr>
                <td valign="top">
                  <div id="Fields" className="propertyName">
                    Fields
                  </div>
                </td>
                <td>
                  <FieldsTable
                    entity={entity}
                    onTypeClicked={onTypeClicked}
                    filter={filter}
                  />
                </td>
              </tr>
              {entity.relations && entity.relations.length > 0 ? (
                <RelationsTable
                  entity={entity}
                  filter={filter}
                  onTypeClicked={onTypeClicked}
                />
              ) : null}
              {entity.validStates && entity.validStates.length > 0
                ? this.renderValidStates(entity)
                : null}
              {entity.possibleLinks && entity.possibleLinks.length > 0 ? (
                <LinksTable
                  filter={filter}
                  entity={entity}
                  onTypeClicked={onTypeClicked}
                />
              ) : null}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}
